import { css } from 'styled-components';
import * as styledVars from '@capillarytech/cap-ui-library/styled/variables';

const {
  FONT_COLOR_04,
  FONT_SIZE_S,
  FONT_SIZE_M,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_MEDIUM,
  CAP_SPACE_08,
  CAP_SPACE_16,
  CAP_SPACE_20,
} = styledVars;

export default css`
  .navigation-setting-icon-disabled {
    color: ${FONT_COLOR_04};
  }
  .cap-component-wrapper {
    max-width: 81.429rem !important;
    .coming-soon-tooltip {
      max-width: max-content;
      .coming-soon-section {
        flex-direction: column;
        gap: ${CAP_SPACE_08};
        .coming-soon-text {
          font-size: ${FONT_SIZE_M};
          font-weight: ${FONT_WEIGHT_MEDIUM};
          line-height: ${CAP_SPACE_20};
        }
        .coming-soon-subtext {
          font-size: ${FONT_SIZE_S};
          font-weight: ${FONT_WEIGHT_REGULAR};
          line-height: ${CAP_SPACE_16};
        }
      }
    }
  }

  .badges-settings-container {
    .ant-menu-horizontal > .ant-menu-item {
      display: flex !important;
    }
  }
`;
